import { useMutation } from 'Data/Api.js'
import { useDataValue } from 'Simple/Data'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data, reExecuteQuery) {
  let onActionCreate = useDataOnActionCreate(props, data)

  return async function onSubmit({ args }) {
    switch (args.type) {
      case 'create':
        return onActionCreate({ reExecuteQuery })
      default:
        return
    }
  }
}

/** @type {import('Simple/types.js').useDataOnSubmit} */
function useDataOnActionCreate(props) {
  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()
  let location_id = useDataValue({
    context: 'tab',
    path: 'selected.location_id',
    viewPath: props.viewPath,
  })
  let patient_id = useDataValue({
    context: 'appointment_overlay',
    path: 'patient_id',
    viewPath: props.viewPath,
  })

  return async function onAction({ reExecuteQuery }) {
    let mutationResponse = await executeMutation({
      patient_id,
      location_id,
    })
    if (mutationResponse.error) {
      notify(notifyError('Something went wrong'))
    } else {
      notify(notifySuccess('Treatment created'))
      return reExecuteQuery({ requestPolicy: 'network-only' })
    }
  }
}
